import { Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

export class SurveyStreamSegregator<T extends { svp_child_id: number }> {
  constructor(
    private readonly _navigationExtras$: Observable<T>,
    private readonly _routeId: number
  ) {}

  public notSvpChildSurveyIdStream(): Observable<number> {
    return of(this._routeId).pipe(
      switchMap(() => this._navigationExtras$),
      filter((extras) => !extras.svp_child_id),
      map(() => this._routeId)
    );
  }

  public svpChildSurveyIdStream(): Observable<number> {
    return of(0).pipe(
      switchMap(() => this._navigationExtras$),
      filter((extras) => !!extras.svp_child_id),
      map((extras) => Number(extras.svp_child_id))
    );
  }
}
